import type { JSX } from 'react';
import {
  LOGO_BODY_PATH,
  LOGO_COLOURS,
  LOGO_ELLIPSE,
  LOGO_VIEWBOX,
  PRACTICE_NAME,
  type LogoTone,
} from '@fatigue/shared';

interface Props {
  readonly size?: number;
  /** Defaults to the supplied brand colours; this app is light. */
  readonly tone?: LogoTone;
  /** Set when the mark is the only thing identifying the practice. */
  readonly title?: string;
}

/** The Midwinter Physiotherapy mark. Geometry from `@fatigue/shared`. */
export function Logo({ size = 22, tone = 'brand', title }: Props): JSX.Element {
  const colours = LOGO_COLOURS[tone];

  return (
    <svg
      width={size}
      height={size}
      viewBox={LOGO_VIEWBOX}
      role={title === undefined ? 'presentation' : 'img'}
      aria-hidden={title === undefined}
      aria-label={title}
      style={{ display: 'block', flexShrink: 0 }}
    >
      {title !== undefined && <title>{title === '' ? PRACTICE_NAME : title}</title>}
      <path d={LOGO_BODY_PATH} fill={colours.body} />
      <ellipse
        cx={LOGO_ELLIPSE.cx}
        cy={LOGO_ELLIPSE.cy}
        rx={LOGO_ELLIPSE.rx}
        ry={LOGO_ELLIPSE.ry}
        fill={colours.ellipse}
      />
    </svg>
  );
}
